import { i18n } from '@fs/zion-locale'

export default {
  cameraOperator: () => i18n.t('internal.cameraOperator', 'Camera Operator'),
  heading: () => i18n.t('internal.heading', 'Internal Staff Options'),
  imageApid: () => i18n.t('internal.imageApid', 'Image APID'),
  imageArk: () => i18n.t('internal.imageArk', 'Image ARK'),
  imagePermissions: () => i18n.t('internal.imagePermissions', 'Image Permissions'),
  groupPermissions: () => i18n.t('internal.groupPermissions', 'Group Permissions'),
  manageJiapuGroup: () => i18n.t('Internal.manageJiapuGroup', 'Manage Jiapu Group'),
  mediaNumber: () => i18n.t('internal.mediaNumber', 'Media Number'),
  naturalGroupIds: () => i18n.t('internal.naturalGroupIds', 'Natural Group ID'),
  openFullHistory: () => i18n.t('internal.openFullHistory', 'Open Full Change History'),
  projectId: () => i18n.t('internal.projectId', 'Project ID'),
  redactionEditorHeading: () => i18n.t('internal.redactionEditor.heading', 'Redaction Editor'),
  redactionEditorDescription: () =>
    i18n.t('internal.redactionEditor.description', 'Add, adjust, or remove redaction areas on this image.'),
  redactionEditorButtonText: () => i18n.t('internal.redactionEditor.buttonText', 'Open Editor'),
  openEditor: () => i18n.t('internal.redactionEditor.openEditor', 'Open Editor'),
  subheading: () => i18n.t('internal.subheading', 'Visible only to employees and missionaries'),
}
